<nav class="tm-main-nav navbar navbar-expand-lg py-0" [ngClass]="{'devMode': devMode}">
    <div class="container-fluid">
        @if(topMenu){
            <div class="d-flex justify-content-between w-100 align-items-center">
                <div class="d-flex align-items-center">
                    <a class="navbar-brand" routerLink="/home">TeamMood</a>
        
                    @if(topMenu?.teamMoodAdminMenu){
                    <!-- TeamMood Admin Menu -->
                    <ul class="navbar-nav flex-column-reverse flex-lg-row-reverse align-items-center" [ngClass]="{devMode: devMode, 'd-none d-lg-flex': topMenu?.teamMoodAdminMenu}">
                        @for(item of topMenu?.teamMoodAdminMenu; track item){
                            @if(item.linkType =='link'){
                                <li class="nav-item mx-lg-2">
                                    <a class="nav-link" [routerLink]="item.teamId? [item.stateName, item.teamId]: [item.stateName]" title="{{item.name | translate}}">
                                        <i class="{{item.icon}}"></i>&nbsp;{{item.name | translate}}
                                    </a>
                                </li>
                            }
                        }
                    </ul>
                    }
                </div>
                <!-- Right nav menu-->
                <ul class="navbar-nav d-flex flex-row align-items-center" [ngClass]="{devMode: devMode}">
                    <!-- Call to action -->
                    <li class="nav-item mx-lg-2 call-to-action">
                        @if(topMenu?.callToActionMenu?.linkType =='button'){
                        <span>
                            <a class="btn btn-primary navbar-btn remain-btn" [routerLink]="topMenu.callToActionMenu.teamId?[topMenu.callToActionMenu.stateName, topMenu.callToActionMenu.teamId]:[topMenu.callToActionMenu.stateName]" title="{{topMenu.callToActionMenu.name | translate}}">{{topMenu.callToActionMenu.name | translate:{trial_count: topMenu.callToActionMenu.trial_count} }}</a>
                        </span>
                        }
                    </li>     
        
                    <!-- Personal settings -->
                    <li class="nav-item mx-lg-2 dropdown">
                        <header-menu menuName="personalSettingsMenu"
                                     menuTitle=""
                                     menuIcon="far fa-gear"
                                     [menuItems]="topMenu.personalSettingsMenu"></header-menu>
                        
                    </li> 
                                    
                    <!-- Notification bell - todo: manage zero notifications -->
                    <li class="nav-item dropdown">
                        <button mat-button [matMenuTriggerFor]="notificationMenu" (click)="getFeed()" class="dropdown-toggle nav-link dropdown-toggle-tm">
                            <i class="far fa-bell fa-lg"></i>
                            @if(topMenu?.unread_feed_items_count > 0){
                                <span class="badge rounded-pill bg-danger">{{topMenu?.unread_feed_items_count}}</span>
                            }
                        </button>
                        <mat-menu #notificationMenu="matMenu" [hidden]="feed?.length === 0">
                            <ul class="navbar-nav d-lg-flex align-items-lg-center feed" >
                                @for(feed_item of feed; track feed_item){
                                <li mat-menu-item class="dropdown-item px-3 pt-1 pb-0" (click)="feed_item.click()">
                                    <div>
                                        <i class="far fa-circle fa-xs unread" [ngClass]="{'read': feed_item.read, 'unread': !feed_item.read}"></i>
                                        <strong class="text-dark ps-1 pe-3">{{feed_item.title}}</strong>
                                        <span class="badge bg-success float-end">{{feed_item.time}}</span>
                                    </div>
                                    <div>
                                        {{feed_item.details}}
                                    </div>
                                </li>
                                }
                            </ul>
                        </mat-menu>
                    </li>
                
                    <!-- Help -->
                    <li class="nav-item dropdown">
                            <header-menu menuName="helpMenu"
                                        menuIcon="far fa-lg fa-question-circle"
                                        [menuItems]="topMenu.helpMenu"></header-menu>
                    </li>
            
                    <!-- User account -->
                    <li class="nav-item mx-lg-2 dropdown">
                            <header-menu menuName="accountMenu"
                                        [userInfos]="userInfos"
                                        [menuItems]="topMenu.accountMenu"></header-menu>
                    </li>
                </ul>
            </div>
        }        
    </div>
</nav>
